export default __webpack_public_path__ + "Asset_Content_Change.79d20a038afd18112f19f84a07902eed.jpg";